import { gql } from '@apollo/client';

export const GET_SERVICIO_ID = gql`
  {
    getServicioId @client
  }
`;

export const GET_SERVICIO = gql`
  query getServicio($id: ID!) {
    getServicio(id: $id) {
      _id
      titulo
      resumen
      contenido
    }
  }
`;

export const GET_SERVICIOS = gql`
  query getServicios($paginate: getServiciosPaginate!) {
    getServicios(paginate: $paginate) {
      servicios {
        node {
          _id
          titulo
          resumen
          contenido
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const SEARCH_SERVICIOS = gql`
  query searchServicios($paginate: searchServiciosPaginate!) {
    searchServicios(paginate: $paginate) {
      cuentos {
        node {
          _id
          titulo
          resumen
          contenido
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const ADD_SERVICIO = gql`
  mutation createServicio($input: CreateServicioInput!) {
    createServicio(input: $input) {
      _id
      titulo
      resumen
      contenido
      code
      success
      message
    }
  }
`;

export const UPDATE_SERVICIO = gql`
  mutation updateServicio($input: UpdateServicioInput) {
    updateServicio(input: $input) {
      _id
      titulo
      resumen
      contenido
      code
      success
      message
    }
  }
`;

export const REMOVE_SERVICIO = gql`
  mutation removeServicio($input: DeleteServicioInput!) {
    removeServicio(input: $input) {
      code
      success
      message
    }
  }
`;
